import { createReducer, on } from '@ngrx/store';
import { Storefront } from '../../models';
import * as actions from '../actions/active-storefront.action';
import * as utility from '../../../utility';

export interface ActiveStorefrontState {
  active?: Storefront;
  loaded: boolean;
  loading: boolean;
  error?: any;
}

export const initialState: ActiveStorefrontState = {
  active: undefined,
  loaded: false,
  loading: false,
};

export const activeStorefrontReducer = createReducer(
  initialState,
  on(actions.LoadActiveStorefront, (state: ActiveStorefrontState) => {
    return {
      ...state,
      loading: true,
      error: null,
    };
  }),
  on(actions.LoadActiveStorefrontSuccess, (state: ActiveStorefrontState, { storefront }) => {
    return {
      ...state,
      active: storefront,
      loading: false,
      loaded: true,
      error: null,
    };
  }),
  on(actions.LoadActiveStorefrontFail, (state: ActiveStorefrontState, { error }) => {
    return {
      ...state,
      loading: false,
      loaded: false,
      error,
    };
  })
);

export const getActiveStorefront = (state: ActiveStorefrontState) => state.active;
export const getActiveStorefrontLoading = (state: ActiveStorefrontState) => state.loading;
export const getActiveStorefrontLoaded = (state: ActiveStorefrontState) => state.loaded;
export const getActiveStorefrontError = (state: ActiveStorefrontState) => state.error;
